import { useContext } from 'react';
import LangContext from '../context/langContext';

export default () => useContext(LangContext)